/* eslint-disable react/no-unescaped-entities */
import React from "react";
import PageHero from "@/components/landing/PageHero";
import PageMeta from "@/components/PageMeta";

const SECTIONS = [
  {
    h: "1. Acceptance of these terms",
    p: <>By accessing or using Shopbook through its website, web application, mobile application, or related services (collectively, the "Service"), you ("you", "your") agree to these Terms of Service. If you do not agree, do not use the Service. These terms form a legally binding agreement between you and Shopbook.</>,
  },
  {
    h: "2. Eligibility",
    p: <>You must be at least 18 years old and able to enter into a binding contract under the laws of your country. By using Shopbook you confirm that you are.</>,
  },
  {
    h: "3. Your account",
    p: (
      <>
        You are responsible for keeping your PIN, OTP and login credentials confidential, and for all activity that happens under your account. Notify us immediately at <a href="mailto:support@shopbook.tech" className="text-[#0E6B6B] underline">support@shopbook.tech</a> if you suspect unauthorized access.
      </>
    ),
  },
  {
    h: "4. Acceptable use",
    p: (
      <>
        You agree not to:
        <ul className="list-disc pl-6 mt-3 space-y-2">
          <li>Use Shopbook for unlawful, fraudulent or deceptive activity.</li>
          <li>Resell or sublicense Shopbook without our written permission.</li>
          <li>Attempt to reverse-engineer, decompile or disrupt the Service or its infrastructure.</li>
          <li>Upload content that violates the rights of others or applicable law.</li>
        </ul>
        We may suspend or terminate accounts that violate these rules.
      </>
    ),
  },
  {
    h: "5. Subscriptions and payments",
    p: <>Shopbook offers Solo, Starter, Growth and Scale plans. Paid periods may be monthly, quarterly or annual and are billed in advance. Automatic renewal applies only when you explicitly enable it. You can disable renewal while keeping access through the end of the paid period. Refunds are provided where required by applicable law.</>,
  },
  {
    h: "6. Trials and promotions",
    p: <>Free trials do not create an automatic charge. Paid access begins only after you choose a plan, complete checkout and Shopbook verifies the payment. Promotional terms will be shown before you accept an offer.</>,
  },
  {
    h: "7. Your content and data",
    p: <>You retain ownership of all business data you enter into Shopbook ("Your Content"). You grant Shopbook a limited licence to host, process, synchronize, and display Your Content solely to provide, secure, support, and improve the Service for you. We do not sell Your Content and do not use it to train third-party models.</>,
  },
  {
    h: "8. Intellectual property",
    p: <>The Shopbook name, logo, service design, source code and content are owned by Shopbook and protected by intellectual property laws. These Terms do not transfer any ownership to you.</>,
  },
  {
    h: "9. Availability and changes",
    p: <>We strive to keep Shopbook available 24/7 but we do not guarantee uninterrupted service. We may add, change, or remove features at any time. Significant changes will be communicated in-app or by email.</>,
  },
  {
    h: "10. Termination",
    p: <>You can stop using Shopbook and delete your account at any time. We may suspend or terminate accounts that violate these Terms, become inactive for an extended period, or where required by law. On termination, we will provide a reasonable window to export your data.</>,
  },
  {
    h: "11. Disclaimers",
    p: <>Shopbook is provided "as is". We do not warrant that the Service will be error-free, uninterrupted or that it will meet every business requirement. Decisions based on Shopbook reports remain your responsibility.</>,
  },
  {
    h: "12. Limitation of liability",
    p: <>To the maximum extent permitted by law, Shopbook's total liability arising out of or related to these Terms or the Service is limited to the amount you paid us in the 12 months before the event giving rise to the claim. We are not liable for indirect, incidental, consequential or special damages.</>,
  },
  {
    h: "13. Governing law",
    p: <>These Terms are governed by the laws of the Federal Republic of Nigeria, without regard to its conflict of law rules. Disputes shall be resolved in the courts of Lagos, Nigeria, unless required otherwise by applicable consumer protection law.</>,
  },
  {
    h: "14. Changes to these terms",
    p: <>We may update these Terms occasionally. The "Last updated" date reflects the latest revision. Continued use after changes constitutes acceptance.</>,
  },
  {
    h: "15. Contact",
    p: <>Questions? Reach us at <a href="mailto:legal@shopbook.tech" className="text-[#0E6B6B] underline">legal@shopbook.tech</a>.</>,
  },
];

export default function TermsOfService() {
  return (
    <>
      <PageMeta title="Terms of Service" description="The terms governing Shopbook's website, web application, mobile applications, subscriptions, trials, and related services." />
      <PageHero
        eyebrow="Legal"
        title="Terms of Service."
        italicTail=""
        intro="Last updated: August 2026. These terms govern the Shopbook website, web application, mobile applications, and related services."
      />

      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-0 space-y-10">
          {SECTIONS.map((s, i) => (
            <div key={s.h} data-testid={`terms-section-${i}`}>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-[#0A2424]">{s.h}</h2>
              <div className="mt-3 text-base text-[#3a4a4a] leading-[1.75]">{s.p}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
